<template>
  <WarningBar v-if="notOnLogin"/>
  <Header v-if="notOnLogin" />
  <router-view />
</template>

<script setup>
import Header from './components/Header.vue';
import WarningBar from './components/WarningBar.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const notOnLogin = computed(() => route.name !== 'Login');


</script>
